export default __webpack_public_path__ + "static/media/drone-training.39354cf7.jpg";